var render = function () {
  var _vm$me;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-container', [_c('v-row', [_c('v-col', [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "contents-area__inner"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("쿠폰 교환소")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-text-field', {
    staticClass: "w-100 w-md-260px",
    attrs: {
      "name": "searchValue",
      "type": "search",
      "autocomplete": "off",
      "hide-details": "",
      "outlined": "",
      "placeholder": "쿠폰 검색"
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return function () {
          return _vm.$router.push("brand/giftcards/search?search=".concat(_vm.searchValue));
        }($event);
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c('v-icon', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.searchValue,
            expression: "searchValue"
          }],
          staticClass: "mr-1",
          attrs: {
            "size": "28"
          },
          on: {
            "click": function click($event) {
              _vm.searchValue = null;
            }
          }
        }, [_vm._v("mdi-close")]), _c('v-icon', {
          attrs: {
            "size": "28"
          },
          on: {
            "click": function click() {
              return _vm.$router.push("brand/giftcards/search?search=".concat(_vm.searchValue));
            }
          }
        }, [_vm._v("mdi-magnify")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.searchValue,
      callback: function callback($$v) {
        _vm.searchValue = $$v;
      },
      expression: "searchValue"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "font-size-14 font-size-md-16 grey--text text--garken-3 mt-md-n20px mb-20px mb-md-22px"
  }, [_c('p', [_vm._v("* 교환소 내 모든 상품은 나누리 캐시로 교환 할 수 있는 상품입니다. 캐시 외에 구입 불가 합니다.")]), _c('p', [_vm._v("* 본인인증을 진행한 후 30분 동안 교환소 이용이 가능합니다.")]), _c('p', [_vm._v("* 교환 전 본인인증을 진행해 주세요.")])]), _c('giftcard-navi', {
    attrs: {
      "categories": _vm.categories
    },
    on: {
      "setCategory": _vm.setCategory
    }
  }), _c('giftcard-list-2', {
    attrs: {
      "brands": _vm.brands
    }
  }), _c('div', {
    staticClass: "mt-30px mt-md-70px"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "color": "primary",
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search();
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1)])])], 1), !((_vm$me = _vm.me) !== null && _vm$me !== void 0 && _vm$me.ci) && _vm.meLoaded ? _c('v-dialog', {
    attrs: {
      "max-width": "500",
      "width": _vm.$vuetify.breakpoint ? '50%' : '90%',
      "scrollable": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('a', {
    attrs: {
      "href": "/mypage/profile"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/giftcard-popup3.jpg"
    }
  })], 1), _c('div', {
    staticClass: "popup-layer-foot",
    staticStyle: {
      "display": "flex",
      "background-color": "#424242",
      "padding": "10px"
    }
  }, [_c('v-spacer'), _c('v-btn', {
    staticStyle: {
      "color": "white",
      "font-size": "16px"
    },
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("닫기")])], 1)])], 1) : _vm._e()], 1), _c('popup-layer', {
    attrs: {
      "code": "gshop"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }